// ** React Imports
import { useEffect } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** Hooks Import
import { useAuth } from 'src/hooks/useAuth'

const AuthGuard = props => {
  const { children, fallback } = props

  const auth = useAuth()

  const router = useRouter()

  // The access token lives in memory only now (populated by a silent refresh on
  // boot), so there's no synchronous storage value to check - auth.loading gates
  // rendering until that boot sequence resolves, and auth.user is the
  // authoritative "are we logged in" signal once it does.
  useEffect(() => {
    if (!router.isReady || auth.loading) {
      return
    }
    if (!auth.user) {
      if (router.asPath !== '/') {
        router.replace({
          pathname: '/login',
          query: { returnUrl: router.asPath }
        })
      } else {
        router.replace('/login')
      }
    }
  }, [router, router.route, auth.loading, auth.user])

  if (auth.loading) {
    return fallback
  }

  return <>{children}</>
}

export default AuthGuard
